/* eslint-disable */
import * as Types from '../graphql/types.generated';

import { gql } from '@apollo/client';
import { AgentQuoteHeaderFragmentDoc } from './AgentQuoteHeader.generated';
import { AgentConfirmationStepFragmentDoc, ConfirmationStepCopyFragmentDoc } from './quote/ConfirmationStep.generated';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient } from 'lib/apollo';
const defaultOptions = {} as const;
export type QuoteFormVelocifyAgentLookupQueryVariables = Types.Exact<{
  velocifyId: Types.Scalars['Int']['input'];
}>;


export type QuoteFormVelocifyAgentLookupQuery = { __typename?: 'Query', agentCollection?: { __typename?: 'AgentCollection', items: Array<{ __typename?: 'Agent', name?: string | null, slug?: string | null, phoneNumber?: string | null, email?: string | null, licensedYear?: number | null, velocifyId?: number | null, under65Redirect?: string | null, over65Redirect?: string | null, dentalRedirect?: string | null, sys: { __typename?: 'Sys', id: string }, photo?: { __typename?: 'Asset', description?: string | null, url?: string | null, width?: number | null, height?: number | null } | null } | null> } | null };

export type OurPromiseCopyFragment = { __typename?: 'Query', ourPromise?: { __typename?: 'SnippetGroupCollection', items: Array<{ __typename?: 'SnippetGroup', name?: string | null, snippetsCollection?: { __typename?: 'SnippetGroupSnippetsCollection', items: Array<{ __typename?: 'Article' } | { __typename?: 'Snippet', key?: string | null, content?: { __typename?: 'SnippetContent', json: any } | null } | null> } | null } | null> } | null };

export type QuoteSnippetFieldsFragment = { __typename?: 'Snippet', key?: string | null, content?: { __typename?: 'SnippetContent', json: any } | null };

export const QuoteSnippetFieldsFragmentDoc = gql`
    fragment QuoteSnippetFields on Snippet {
  key
  content {
    json
  }
}
    `;
export const OurPromiseCopyFragmentDoc = gql`
    fragment OurPromiseCopy on Query {
  ourPromise: snippetGroupCollection(where: {key: "quote-our-promise"}) {
    items {
      name
      snippetsCollection(limit: 10) {
        items {
          ... on Snippet {
            ...QuoteSnippetFields
          }
        }
      }
    }
  }
}
    ${QuoteSnippetFieldsFragmentDoc}`;
export const QuoteFormVelocifyAgentLookupDocument = gql`
    query QuoteFormVelocifyAgentLookup($velocifyId: Int!) {
  agentCollection(where: {velocifyId: $velocifyId}, limit: 1) {
    items {
      ...AgentQuoteHeader
      ...AgentConfirmationStep
    }
  }
}
    ${AgentQuoteHeaderFragmentDoc}
${AgentConfirmationStepFragmentDoc}`;

/**
 * __useQuoteFormVelocifyAgentLookupQuery__
 *
 * To run a query within a React component, call `useQuoteFormVelocifyAgentLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteFormVelocifyAgentLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteFormVelocifyAgentLookupQuery({
 *   variables: {
 *      velocifyId: // value for 'velocifyId'
 *   },
 * });
 */
export function useQuoteFormVelocifyAgentLookupQuery(baseOptions: Apollo.QueryHookOptions<QuoteFormVelocifyAgentLookupQuery, QuoteFormVelocifyAgentLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteFormVelocifyAgentLookupQuery, QuoteFormVelocifyAgentLookupQueryVariables>(QuoteFormVelocifyAgentLookupDocument, options);
      }
export function useQuoteFormVelocifyAgentLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteFormVelocifyAgentLookupQuery, QuoteFormVelocifyAgentLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteFormVelocifyAgentLookupQuery, QuoteFormVelocifyAgentLookupQueryVariables>(QuoteFormVelocifyAgentLookupDocument, options);
        }
export type QuoteFormVelocifyAgentLookupQueryHookResult = ReturnType<typeof useQuoteFormVelocifyAgentLookupQuery>;
export type QuoteFormVelocifyAgentLookupLazyQueryHookResult = ReturnType<typeof useQuoteFormVelocifyAgentLookupLazyQuery>;
export type QuoteFormVelocifyAgentLookupQueryResult = Apollo.QueryResult<QuoteFormVelocifyAgentLookupQuery, QuoteFormVelocifyAgentLookupQueryVariables>;
export async function getServerPageQuoteFormVelocifyAgentLookup
    (options: Omit<Apollo.QueryOptions<QuoteFormVelocifyAgentLookupQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<QuoteFormVelocifyAgentLookupQuery>({ ...options, query: QuoteFormVelocifyAgentLookupDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageQuoteFormVelocifyAgentLookupComp = React.FC<{data?: QuoteFormVelocifyAgentLookupQuery, error?: Apollo.ApolloError}>;
export const ssrQuoteFormVelocifyAgentLookup = {
      getServerPage: getServerPageQuoteFormVelocifyAgentLookup,
      
      
    }